import { render, staticRenderFns } from "./ListItemDate.vue?vue&type=template&id=5aaa27a2&scoped=true&"
import script from "./ListItemDate.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemDate.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ListItemDate.vue?vue&type=style&index=0&id=5aaa27a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaa27a2",
  null
  
)

export default component.exports